import * as React from 'react';
import { ProtectedPageWrapper } from '../../designSystem/layouts/pageWrappers/ProtectedPageWrapper';
import { AgendaMeetingListingView } from '../_components/activities/AgendaMeetingListingView';




export default function WorkgroupMeetingListingPage(): JSX.Element 
{

    React.useEffect(() =>
    {
        document.title = 'Amorgy - AMO møder';
    }, []);

	return (
		<ProtectedPageWrapper requiredPermissions={['ViewActivity']} selectedMenuItemKey="workgroupmeeting">
            <AgendaMeetingListingView
                currentActivitiesHeaderIcon='calendar'
                createNewButtonText='Opret nyt AMO møde'
                currentActivitiesHeaderText='Aktuelle AMO møder'
                pastActivitiesHeaderText='TIDLIGERE AMO MØDER'
                pastActivitiesHeaderIcon='calendar_check'
                type='WorkgroupMeeting' />
		</ProtectedPageWrapper>
	);
}
